import React from 'react'

import { useExchanger } from './_hooks/exchanger'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import Center from '../../../packages/kiti/components/helpers/Center'
import CheckinServiceContext, { useCheckinHandlerResult } from './ServiceContext'
import CloseButton from './CloseButton'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import LoadingWrapper from '../../../packages/kiti/components/helpers/LoadingWrapper'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text from '../../../packages/kiti/components/presentation/Text'
import useServiceEventMessages from './_hooks/serviceEventMessageHandler'

const IntegrationCheckInServicePage = () => {
  const handleServiceCheckin = useExchanger()
  const messages = useServiceEventMessages()
  const [handlerResult] = useCheckinHandlerResult()

  React.useEffect(() => {
    handleServiceCheckin()
  }, [])

  return (
    <AbsolutePageTemplate>
      <Separator weight={50} />
      <LoadingWrapper loading={handlerResult === `loading`}>
        <Center>
          <div style={{ width: 500 }}>
            <Center>
              <Icon name={messages.icon} size={6} color={messages.colorIcon} />
            </Center>

            <Separator weight={8} />
            <Center>
              <Text size="h3" bold>
                {messages.title}
              </Text>
            </Center>

            <Center>
              <Text align="center">{messages.subtitle}</Text>
            </Center>

            <Separator weight={6} />
            <Center>
              <CloseButton />
            </Center>
          </div>
        </Center>
      </LoadingWrapper>
    </AbsolutePageTemplate>
  )
}

const Wrapper = () => {
  return (
    <CheckinServiceContext>
      <IntegrationCheckInServicePage />
    </CheckinServiceContext>
  )
}

export default Wrapper
